import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueCookies from 'vue3-cookies'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './styles/shared-view.css'
import { AgGridVue } from 'ag-grid-vue3'
// import { themeAlpine } from 'ag-grid-community'
// import 'ag-grid-community/styles/ag-grid.css'
// import 'ag-grid-community/styles/ag-theme-alpine.css'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { MasterDetailModule, RichSelectModule } from 'ag-grid-enterprise'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn')
// dayjs.tz.setDefault('Asia/Shanghai')

ModuleRegistry.registerModules([
  AllCommunityModule,
  MasterDetailModule,
  RichSelectModule,
])

createApp(App)
  .use(store)
  .use(router)
  .use(VueCookies, { expireTimes: '7d' })
  .use(Antd)
  .component('AgGridVue', AgGridVue)
  .mount('#app')
